import catBreedsData from "@/app/constants/breeds/catBreeds.json";
import dogBreedsData from "@/app/constants/breeds/dogBreeds.json";
import giantBreedsData from "@/app/constants/breeds/giantBreeds.json";
import type { BreedRow } from "@/app/constants/breeds/types";

const catBreeds = catBreedsData as BreedRow[];
const dogBreeds = dogBreedsData as BreedRow[];
const giantBreeds = giantBreedsData as BreedRow[];

export const useBreedConstants = () => {
  return {
    catBreeds,
    dogBreeds,
    giantBreeds,
  };
};
